/**
 * @desc 创建模板
 */
import { TemplateEntity } from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateTemplateParameter = TemplateEntity

const method = 'POST'
const url = '/contract/template'

export const createTemplateApi = (
  data?: CreateTemplateParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<TemplateEntity>({
    method,
    url,
    data,
    ...config
  })
}

createTemplateApi.method = method
createTemplateApi.url = url
